import { BaseRepository } from 'CMS/Data/Repositories/BaseRepository';
import * as $ from 'jquery';
import * as app from 'CMS/core/application';

export default class WebpageRepository extends BaseRepository<any> {

    // See constructor
    private GETWEBPAGEURL = "";
    private GETWEBPAGEURLS = "";

    private static WEBPAGEREFERENCE_CACHE: { [key: string]: string } = {};

    private readonly REFERENCE_KEY_SEPERATOR = ';';

    constructor() {
        super();
        this.GETWEBPAGEURL = app.formatLocationUrl("~/CMS/api/webpage/getwebpageurl?referenceKey=");
        this.GETWEBPAGEURLS = app.formatLocationUrl("~/CMS/api/webpage/getwebpageurls?referenceKeys=");
    }

    public list(): Promise<any[]> {
        throw new Error('Not implemented');
    }

    public get(id: string): Promise<any> {
        throw new Error('Not implemented');
    }

    private isCached(referenceKey: string): boolean {
        return this.getFromCache(referenceKey) != null;
    }
    private getFromCache(referenceKey: string): string {
        return WebpageRepository.WEBPAGEREFERENCE_CACHE[referenceKey.toUpperCase()];
    }
    private getAllFromCache(referenceKeys: string[]): Map<string, string> {
        let urls = new Map<string, string>();
        for (let i = 0; i < referenceKeys.length; i++) {
            let referenceKey = referenceKeys[i];
            let url = this.getFromCache(referenceKey);
            urls.set(referenceKey.toUpperCase(), url);
        }
        return urls;
    }
    private storeToCache(referenceKey: string, url: string) {
        return WebpageRepository.WEBPAGEREFERENCE_CACHE[referenceKey.toUpperCase()] = url;
    }

    public getWebpageURL(referenceKey: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const cachedUrl = this.getFromCache(referenceKey);
            if (cachedUrl != null) {
                resolve(cachedUrl);
            } else {
                var $get = $.get(this.GETWEBPAGEURL + referenceKey);
                $get.then((webPageUrl: string) => {
                    this.storeToCache(referenceKey, webPageUrl);
                    resolve(webPageUrl);
                }, (error) => {
                    reject(error);
                });
            }
        });
    }

    public getWebpageURLs(referenceKeys: string[]): Promise<Map<string, string>> {
        return new Promise<Map<string, string>>((resolve, reject) => {
            /* Check for cached keys */
            let uncachedKeys: string[] = [];
            for (let i = 0; i < referenceKeys.length; i++) {
                let referenceKey = referenceKeys[i];
                if (!this.isCached(referenceKey)) {
                    uncachedKeys.push(referenceKey);
                }
            }

            /* Request all uncached keys */
            if (uncachedKeys.length > 0) {
                var $get = $.get(this.GETWEBPAGEURLS + uncachedKeys.join(this.REFERENCE_KEY_SEPERATOR));
                $get.then((data) => {
                    var urls = new Map<string, string>();
                    var keys = Object.keys(data);
                    for (let i = 0; i < keys.length; i++) {
                        this.storeToCache(keys[i], data[keys[i]]);
                    }

                    resolve(this.getAllFromCache(referenceKeys));
                }, (error) => {
                    reject(error);
                });
            } else {
                resolve(this.getAllFromCache(referenceKeys));
            }

        });
    }

}

